module.exports = global.config = {
  variables: {
    // local
    // strDomainUrl: "/",
    // strApiUrl: "http://localhost:3002",
    // strApiUrl: "http://192.168.2.111:3002",
    // strApiUrl: "http://192.168.2.203:3003",

    //192
    //  strDomainUrl: "http://192.168.2.2/g/gesh-react/website/",
    //  strApiUrl: "http://192.168.2.2:3013",

    //beta gesh 192
    // strDomainUrl: "http://192.168.2.2/g/gesh-react/gesh-beta/website/",
    //  strApiUrl: "http://192.168.2.2:3013",

    //  strDomainUrl: "http://192.168.2.2/g/gesh-react/website/",

    //IIT
    // strDomainUrl: "https://geshiitb.in/",
    // live api url
    // strApiUrl: "https://geshiitb-api.azurewebsites.net",

    //Beta api url
    // strApiUrl: "https://geshiitb2025-api.azurewebsites.net",

    //Beta 2025 IIT
    // strDomainUrl: "https://geshiitb2025.azurewebsites.net/",
    // strApiUrl: "https://geshiitb2025-api.azurewebsites.net",

    //gesh IITB Server
    strDomainUrl: "https://gesh.iitb.ac.in/",
    strApiUrl: "https://gesh.iitb.ac.in/site",

    // rest of your translation object  /a/1_Akshay/gesh-react-web

    //road block id
    strRoadBlock_id: "73a98b08-d383-11ed-918d-5254fbc0d86c",
    strSetting_id: "ebbf9735-dce5-11ed-9246-10e7c607eeca",
    //Ganeral news type id
    strNewsTypeGeneral_id: "5c8432d2-34ea-11ee-ac53-f8b156be9900",

    //events training and programme id
    strTrainingProgramme_id: "88ad9a54-81b1-11f0-9098-bc2411738d23",

    strSustainabilityResearchAtIITB_id: "1d0d5011-1c06-11ef-9b87-f8b156be9900",
    researchItemPerPage: 10,
  },
  // other global config variables you wish
};
